import axios from 'axios';
import {httpAuth,http} from "../plugins/http";
 let endpoint = '/'

export default {
    login: (username,password) => {
        return httpAuth.post(endpoint,{},{
          headers:{
            usuario: username,
            senha: password
          }}
         )
    },
    getUser:()=>{
        return http.get(endpoint+'user',{
            headers:{'Authorization': 'Bearer '+localStorage.getItem('token')}
        })
    },
    renovarToken:()=>{
        var authBase = process.env.VUE_APP_AUTH_URL || ''
        var serverUrl = authBase.replace(/\/v1\/api\/seg\/autenticacao\/?$/, '')
        return axios.post(serverUrl + '/v1/api/seg/token/renovacao', {}, {
            headers:{
                'token': localStorage.getItem('tokenAtualizacao')
            }
        })
    }
}
